import React from 'react';
import { motion } from 'framer-motion';
const ebooks = [{
  image: 'https://cdn.magicpatterns.com/uploads/dD6pYLeS5wiiBNvnQXkrtH/1._MOCKUP_HOGAR_BLINDADO.png',
  title: 'Hogar Blindado – Adiós Piojos',
  benefit: 'Elimina y previene los piojos con un método natural de 3 pasos. Sin químicos agresivos, sin estrés.',
  color: 'bg-[#F5F0E8]'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/6WqkUEARiohL8xfD2zrwiu/2._MOCKUP_NOCHES_SECAS_.png',
  title: 'Noches Secas – Adiós pipí en la cama',
  benefit: 'Acompaña a tu hijo con respeto y comprensión para superar el pipí nocturno sin castigos ni presión.',
  color: 'bg-[#FBF8F4]'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/guuUVLvWHf6UKdKd8L61xe/3._MOCKUP_FRESCOS_Y_SEGUROS.png',
  title: 'Frescos y Seguros – Higiene Infantil',
  benefit: 'Guía completa de higiene natural para niños. Rutinas sencillas que cuidan su salud y autonomía.',
  color: 'bg-[#F5F0E8]'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/rwaaApR9Sn5n1wmLPkKrce/4._MOCKUP_ADIOS_BERRINCHES.png',
  title: 'Adiós Berrinches',
  benefit: 'Comprende las rabietas desde el respeto. Herramientas prácticas para acompañar las emociones de tu hijo sin gritos ni castigos.',
  color: 'bg-[#FBF8F4]'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/nCq2yt1nU1Rn49F2RFuxfY/5._MOCKUP_DULCES_SUENOS.png',
  title: 'Dulces Sueños – Sueño Feliz',
  benefit: 'Mejora el descanso de toda la familia con un método respetuoso que ayuda a tu hijo a dormir tranquilo.',
  color: 'bg-[#F5F0E8]'
}];
export function EbookShowcase() {
  return <section className="py-24 px-4 bg-white" data-id="element-13">
      <div className="max-w-6xl mx-auto" data-id="element-14">
        <div className="text-center mb-20" data-id="element-15">
          <h2 className="font-serif text-3xl md:text-4xl text-[#3D3229] mb-4" data-id="element-16">
            Lo que incluye la primera parte del pack
          </h2>
          <p className="text-[#5C4A3A] max-w-2xl mx-auto" data-id="element-17">
            Cada e-book es una herramienta específica para un problema concreto.
            Sin relleno, directo a la solución.
          </p>
        </div>

        <div className="space-y-24" data-id="element-18">
          {ebooks.map((ebook, index) => <motion.div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12 lg:gap-20`} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-19">
              {/* Image Side */}
              <div className="w-full lg:w-1/2 flex justify-center" data-id="element-20">
                <div className="relative w-full max-w-md aspect-[4/5]" data-id="element-21">
                  <div className={`absolute inset-0 ${ebook.color} rounded-3xl -rotate-3 scale-105 -z-10`} data-id="element-22" />
                  <img src={ebook.image} alt={ebook.title} className="w-full h-full object-contain drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-23" />
                </div>
              </div>

              {/* Content Side */}
              <div className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-24">
                <span className="inline-block text-[#5A7D60] font-medium tracking-wider text-sm uppercase mb-4" data-id="element-25">
                  E-book #{index + 1}
                </span>
                <h3 className="font-serif text-3xl md:text-4xl text-[#3D3229] mb-6 leading-tight" data-id="element-26">
                  {ebook.title}
                </h3>
                <p className="text-lg text-[#5C4A3A] leading-relaxed mb-8" data-id="element-27">
                  {ebook.benefit}
                </p>
                <div className="w-full h-px bg-[#EBE5DB] mb-8" data-id="element-28" />
                <ul className="space-y-3 text-[#5C4A3A]/80" data-id="element-29">
                  <li className="flex items-center gap-3 justify-center lg:justify-start" data-id="element-30">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#5A7D60]" data-id="element-31" />
                    Lectura rápida y práctica
                  </li>
                  <li className="flex items-center gap-3 justify-center lg:justify-start" data-id="element-32">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#5A7D60]" data-id="element-33" />
                    Estrategias aplicables hoy mismo
                  </li>
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}